<template>
  <layout-card-wrap
    v-loading="loading"
    style="margin-top:15px"
    hasHeaderSlot>
    <template slot="title">关联批次
      <el-button
        v-if="editable"
        type="primary"
        :disabled="len === 0 && tradeType === 1"
        style="margin-left: 10px"
        @click="associate">关联</el-button>
    </template>
    <el-table
      border
      height="600"
      :data="inspect.batchs">
      <el-table-column
        :resizable="false"
        width="180"
        label="商品批次号"
        prop="batchCode">
      </el-table-column>
      <el-table-column
        :resizable="false"
        label="商品名称"
        prop="productName">
      </el-table-column>
      <el-table-column
        width="160"
        label="商品数量"
        :resizable="false"
        prop="goodsCount">
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="140"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat() }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="editable"
        label="操作"
        width="90"
        :resizable="false">
        <template slot-scope="{row,$index}">
          <el-button
            v-if="editable"
            type="danger"
            @click="deleteitem(row,$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <associate-batch-modal
      ref="modal"
      :selected="inspect.batchs"
      :option="{tradeType: tradeType, vendorId: vendorId, productIds: productIds}"
      @update:selection="handleSelectionChange" />
  </layout-card-wrap>
</template>

<script>
import AssociateBatchModal from './associate-batch-modal.vue'
export default {
  name: 'AssociateBatch',
  components: { AssociateBatchModal },
  props: {
    loading: [Boolean],
    editable: {
      type: Boolean,
      default: true
    },
    tradeType: [Number, String],
    vendorId: [Number, String],
    value: {
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    inspect: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      return this.inspect.inspectReportDetails ? this.inspect.inspectReportDetails.length : 0
    },
    productIds() {
      return (this.inspect.inspectReportDetails || []).map(i => i.productId)
    }
  },
  watch: {
    len() {
      const detail = this.inspect.inspectReportDetails.map(i => i.productId)
      const ret = this.inspect.batchs.filter(i => detail.indexOf(i.productId) === -1)
      const ret1 = this.inspect.batchs.filter(i => detail.indexOf(i.productId) > -1)
      this.inspect.batchs = ret1
      this.$refs.modal.reset(ret)
    }
  },
  methods: {
    deleteitem(row, index) {
      console.log(row, index)
      this.inspect.batchs.splice(index, 1)
    },
    associate() {
      this.$refs.modal.toggleModal(true)
    },
    handleSelectionChange(rows) {
      this.inspect.batchs = rows
    },
    getIds() {
      return this.inspect.batchs.map(item => item.batchId)
    }
  }
}
</script>
